/**
 * @file: Trade.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 营收
 */
import request from '@/utils/request'

/**
 * 承包商峰值（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function tradeDcTodayPeekList(data) {
  return request({
    type: 'biz',
    url: 'trade/dc/today/peek/list',
    method: 'post',
    data
  })
}

/**
 * 食堂今天每小时时段客流、预测客流、营收（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function tradeDeptHourPstListGet(data) {
  return request({
    type: 'biz',
    url: 'trade/dept/hour/pst/list/get',
    method: 'post',
    data
  })
}

/**
 * 今日食堂峰值（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function tradeDeptTodayPeekList(data) {
  return request({
    type: 'biz',
    url: 'trade/dept/today/peek/list',
    method: 'post',
    data
  })
}

/**
 * 每月收支列表（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function tradeIeMonthList(data) {
  return request({
    type: 'biz',
    url: 'trade/ie/month/list',
    method: 'post',
    data
  })
}

/**
 * 时段营收（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function tradePeriod(data) {
  return request({
    type: 'biz',
    url: 'trade/period',
    method: 'post',
    data
  })
}

/**
 * 某承包商时段总体营收情况（包括今日）（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function tradeTotalityContractorPeriod(data) {
  return request({
    type: 'biz',
    url: 'trade/totality/contractor/period',
    method: 'post',
    data
  })
}

/**
 * 某组织/某食堂时段总体营收情况（含今日）（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function tradeTotalityPeriod(data) {
  return request({
    type: 'biz',
    url: 'trade/totality/period',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Trade.js